import {
	FCM_ENABLE_PETITION_STRENGTH_TIPS,
	FCM_EXPORT_SIGNATURE_BLOCKLIST,
	FCM_GLOBAL_SHARE_BUTTON_CONFIG,
	FCM_PACIFIC_PROMO_FREE_SAMPLE,
	FCM_PETITION_UPDATE_EMAIL_PREVIEW_ENABLED,
	FCM_STARFISH_MULTIPLE_QRCODE_FLYERS,
	FCM_STARFISH_SHARE_VISUALS,
	FCM_STARFISH_STARTER_DASHBOARD_SIGNATURE_SOURCES,
	FCM_STARFISH_STARTER_DM_RECOMMENDER,
	FCM_STARTER_DASHBOARD_DECISION_MAKERS_LIST_ENABLED,
	FCM_STARTER_EXPERIENCE_DASHBOARD_TABS,
	FCM_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS,
	FCM_USE_DONATION_LANGUAGE,
} from '@change-corgi/fcm/configs';

import { createFcmContext } from 'src/app/shared/contexts/fcm';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: StarterDashboardV2PageFcmContext,
	FcmProvider: StarterDashboardV2PageFcmContextProvider,
	useFcm: useStarterDashboardV2PageFcm,
	useAsyncFcm: useAsyncStarterDashboardV2PageFcm,
	prefetchFcm: prefetchStarterDashboardV2PageFcm,
} = createFcmContext({
	name: 'StarterDashboardV2PageFcmContext',
	dataProperty: 'pageFcm',
	configs: {
		shouldUseDonationLanguage: FCM_USE_DONATION_LANGUAGE,
		exportSignatureBlocklist: FCM_EXPORT_SIGNATURE_BLOCKLIST,
		pacificPromoFreeSample: FCM_PACIFIC_PROMO_FREE_SAMPLE,
		strengthTipsEnabled: FCM_ENABLE_PETITION_STRENGTH_TIPS,
		globalShareButtonConfig: FCM_GLOBAL_SHARE_BUTTON_CONFIG,
		starterDashboardDMRecommenderEnabled: FCM_STARFISH_STARTER_DM_RECOMMENDER,
		multipleQrCodeFlyersEnabled: FCM_STARFISH_MULTIPLE_QRCODE_FLYERS,
		topSignatureSourcesConfig: FCM_STARFISH_STARTER_DASHBOARD_SIGNATURE_SOURCES,
		shareVisualsConfig: FCM_STARFISH_SHARE_VISUALS,
		decisionMakersListEnabled: FCM_STARTER_DASHBOARD_DECISION_MAKERS_LIST_ENABLED,
		starterExperienceDashboardTabsConfig: FCM_STARTER_EXPERIENCE_DASHBOARD_TABS,
		starterExperienceShareRecommendationsConfig: FCM_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS,
		petitionUpdateEmailPreviewEnabled: FCM_PETITION_UPDATE_EMAIL_PREVIEW_ENABLED,
	},
	prefetch: true,
});

export type StarterDashboardV2PageFcmState = ReturnType<typeof useAsyncStarterDashboardV2PageFcm>;
export type StarterDashboardV2PageFcm = LoadedStateData<StarterDashboardV2PageFcmState>;
